define(["mw-log/Log"], function (Log) {
  "use strict";

  var _exports = {};
  // Copyright 2023 The MathWorks, Inc.

  const cleanUpEventType = function (eventType) {
    if (!eventType || eventType === 'click') {
      return 'clicked';
    }
    return eventType.replaceAll('_', ' ');
  };
  const cleanUpElementType = function (elementType) {
    if (!elementType) {
      return 'none';
    }
    return elementType.replaceAll('_', ' ');
  };
  const apiKeys = {
    AIRD1_INSIDE: '03d6be60-1a46-434e-be92-c17c9a50f094',
    CLOUD_CENTER: 'fdefc29f-b188-499a-890d-30a4f7e20292',
    COURSE_DESIGNER: 'cb769bb0-24b4-45e1-9c08-867b7f8e09e9',
    CRASHPAD: 'c9da4ed6-644a-4894-bcec-3b89ca1004b4',
    DDUX_CLIENT: '043d5149-7660-4d1f-b76d-7ad796d9e93f',
    DESIGN_CLOUD: 'c3f23819-d508-4150-908e-ba277b1ccf14',
    DESKTOP_MATLAB: 'd8c22ba3-fc0f-4beb-99fc-a109fe9abba9',
    DESKTOP_MSH: '6a221899-611e-4316-ac1c-fbe5ea3a73e6',
    DOC_FEEDBACK: '5bbcb96c-9bb4-4aa2-8ac5-e9f6901ce151',
    GDS: '4b6b6a6b-9f97-4cd5-a3d9-5ddd4884bb9e',
    INSTALLER: '8d12fc5b-5fe5-4643-9b52-10faf10df251',
    MATHWORKS_ACCOUNT: 'faa13f68-6fd9-44e1-a2f8-f7518844efc3',
    MATLABCONNECTOR: 'd9bcd6e7-62b6-4373-b730-3099fef5ca76',
    MATLAB_BATCH: '79afbc4d-971b-452e-acdf-f74571bed523',
    MATLAB_EXTENSION_FOR_VSCODE: '9f77ade3-ae53-4257-8ce9-31f102b34679',
    MATLAB_HOME: '0e53a0f2-a207-4268-90c0-0af01305332c',
    MATLAB_MOBILE: 'c576cb32-359d-4404-856e-cc5d1be06ce0',
    MATLAB_ONLINE: '86d464a0-b0c4-4c8d-a2bd-fa21d43f91f9',
    MATLAB_PACKAGE_MANAGER: '60a2d7f8-da8e-4751-927c-718c4d3d89c5',
    MATLAB_PLAYGROUND: '4f11a381-8a6f-4ac1-a9e1-83691100993c',
    MODELSCAPE: '48973898-99b8-417e-9511-10826c84146c',
    MOSH: 'd4401310-6800-49c2-978a-d80f1d51edd4',
    MOSH_MSH: '426f34b7-48e4-4518-87ba-6b1f0dd43ac0',
    MPI: 'e3847681-5030-46fe-8f73-e64bf7ed5538',
    ONLINE_COURSES: '96d79d60-e6f9-48da-8fc6-7358f335406a',
    POLYSPACE: 'af6fa465-294f-4b72-a942-b53571cbd423',
    PRODUCT_INSTALLER_V2: '86aa5b7b-e4b6-4b3f-9226-7d816bea98aa',
    PRODUCT_UNINSTALLER: '36703c42-9391-4aec-b2f6-3adbf00fb51c',
    SEGV: '6dbe05e3-59cc-4267-ae52-f094e1b643c8',
    SSI: '51dd5d17-5788-4df6-827c-389ff6198cf6',
    UNIFIED_ADDON_INSTALLER: 'b09519c4-8e49-4dee-b1eb-a03e4b11627a',
    UPDATES_INSTALLER: '15af626c-7fc5-42ca-9d1e-ba3e3ddc6cac',
    UPDATE_INSTALLER_V2: 'af238f5a-6efa-4f62-a77e-66b9c72f4b1f',
    VRD: 'a96ba611-1db2-44cc-a4a8-d12835c2903a',
    WEB_PAGE_METRICS: '2369b91c-a64f-11ec-b909-0242ac120002'
  };
  const sendEventToServer = function (eventType, event, sendProperties) {
    let eventData;
    let eventKey;
    if (eventType === 'telemetry') {
      /* Example telemetry event data
        "eventData": {
          "logDDUXData": {
            "product": "ML",
            "keyValues": {
              "activityState": "active",
              "activityType": "UI",
              "previousState": "idle",
              "transitionTime": "2020-12-24T13:32:41.876"
            }
          }
        }
      */
      eventData = {
        logDDUXData: {
          product: event.product,
          keyValues: event.data
        }
      };
      eventKey = event.eventKey;
    } else if (eventType === 'uiEvent') {
      /* Example UI event data
         "eventData": {
           "uiEvent": {
             "productName": "MATLAB",
             "uiScope": "App Designer",
             "elementId": "appDesignerToolstrip.layoutTab.tab",
             "elementType": "toolstrip tab",
             "eventType": "clicked",
             "values": {
               "entry": [
                 {"key": "subscope",
                  "value": "toolstrip"
                 }
               ]
             }
           }
      */
      eventData = {
        uiEvent: {
          productName: event.product,
          uiScope: event.scope,
          elementId: event.elementId,
          elementType: cleanUpElementType(event.elementType),
          eventType: cleanUpEventType(event.eventType)
        }
      };
      eventKey = 'MATLAB_DDUX_UI_EVENT';
      // Find and store any key-value pairs other than the above standard pairs
      const keyValuePairs = [];
      let key;
      let value;
      for ([key, value] of Object.entries(event)) {
        if (key !== 'product' && key !== 'scope' && key !== 'elementId' && key !== 'elementType' && key !== 'eventType') {
          if (key === 'subScope') {
            key = 'subscope';
          }
          keyValuePairs.push({
            key: key,
            value: value
          });
        }
      }
      if (keyValuePairs.length > 0) {
        eventData.values = {
          entry: keyValuePairs
        };
      }
    } else if (eventType === 'custom') {
      eventData = event.data;
      eventKey = event.eventKey;
    } else {
      Log.info('Direct send to server not supported for ' + eventType + ' events');
      return;
    }
    const eventDataString = JSON.stringify(eventData);
    const eventEntry = {
      sessionKey: sendProperties.sessionKey,
      eventKey: eventKey,
      eventDate: new Date().toISOString().slice(0, 23),
      // Slice off trailing 'Z'
      eventData: eventDataString
    };
    if (event.appComponent) {
      eventEntry.applicationComponent = event.appComponent;
    }
    const message = {
      Event: [eventEntry]
    };
    const fetchConfig = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-mw-udc-client-version': '1.0',
        'x-mw-udc-application-name': sendProperties.applicationName,
        'x-mw-udc-application-version': sendProperties.applicationVersion,
        'x-mw-authentication': sendProperties.applicationKey || apiKeys[sendProperties.applicationName]
      },
      body: JSON.stringify(message)
    };
    if (sendProperties.mockFetch) {
      sendProperties.mockFetch(sendProperties.postUrl, fetchConfig);
    } else {
      fetch(sendProperties.postUrl, fetchConfig).then(response => {
        if (!response.ok) {
          Log.warn('DDUX post failed, code  = ' + response.status + ' (' + response.statusText + ')');
        }
      }).catch(error => {
        Log.warn('DDUX post error ' + error);
      });
    }
  };
  _exports.default = sendEventToServer;
  return _exports.default;
});
//# sourceMappingURL=DirectSendFunction.js.map
